import { render, staticRenderFns } from "./ItemDeleteModalWithReasons.vue?vue&type=template&id=58b0dc6c&"
import script from "./ItemDeleteModalWithReasons.vue?vue&type=script&lang=js&"
export * from "./ItemDeleteModalWithReasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports